import { render, staticRenderFns } from "./PageProduction.vue?vue&type=template&id=183d7b2a&"
import script from "./PageProduction.vue?vue&type=script&lang=js&"
export * from "./PageProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports